import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AlertViewComponent } from '../alert-view/alert-view.component';
import { AlertDetailComponent } from '../alert-detail/alert-detail.component';
import { StoreModule } from '@ngrx/store';
import { alertReducer, initialAlertState } from './alerts.action';
import { EffectsModule } from '@ngrx/effects';
import { AlertEffects } from './alerts.effects';

@NgModule({
    declarations: [AlertViewComponent, AlertDetailComponent],
    imports: [
        CommonModule,
        RouterModule,
        StoreModule.forFeature('alert', alertReducer, {
            initialState: initialAlertState
        }),
        EffectsModule.forFeature([AlertEffects])
    ],
    exports: [AlertDetailComponent]
})
export class AlertModule {}
